(ns practitest.frontend.common.attachment-preview)

(def ^:private image-types
  #{"image/gif"
    "image/x-icon"
    "image/jpeg"
    "image/svg+xml"
    "image/tiff"
    "image/webp"
    "image/png"})

(defn- previewable? [attachment]
      (boolean (image-types (:type attachment))))

(defn build-preview
  "Render icon or image preview if the image type is supported. The attachment must contain :data or :thumbnail_url"
  [attachment]
      (if (previewable? attachment)
        [:img {:src   (or (:data attachment) (:thumbnail_url attachment))
               :style {:display      "block"
                       :max-width    "100%"
                       :height       "auto"}}]
        [:i.fa.fa-2x.fa-fw.fa-file]))